module.exports = __webpack_public_path__ + "img/heart-gray.3f18a68.png";